interface CheckboxCheckedIconProps {
  size?: number;
  color?: string;
  bg?: string;
}

const CheckboxCheckedIcon = ({ size = 20, color = "#fff", bg = "#243B6B" }: CheckboxCheckedIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="20" height="20" rx="4" fill={bg} />
    <path
      d="M5 10.5L8.5 14L15 7"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckboxCheckedIcon;
